import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';

import { PeopleService } from '@modules/person-profiles/people.service';

@Injectable({
  providedIn: 'root'
})
export class EmailUnsubscribeResolver implements Resolve<boolean> {
  
  constructor(private peopleSvc: PeopleService) {}
  
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.peopleSvc.unsubscribe(route.params['id']);
  }
}